import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#1a3c34', contrastText: '#ffffff' },
    secondary: { main: '#2d5e55', contrastText: '#ffffff' },
    error: { main: '#dc2626' },
    background: { default: '#f5f7fa', paper: '#ffffff' },
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
    h1: { fontSize: '2.5rem', fontWeight: 700, color: '#1a3c34' },
    h2: { fontSize: '1.8rem', fontWeight: 600, color: '#1a3c34' },
    h3: { fontSize: '1.4rem', fontWeight: 600, color: '#2d5e55' },
    h4: { fontSize: '1.2rem', fontWeight: 500, color: '#2d5e55' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          padding: '12px 25px',
          '&:hover': {
            transform: 'translateY(-2px)',
            transition: 'transform 0.2s ease, background-color 0.3s ease'
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: { '& .MuiOutlinedInput-root': { borderRadius: 8 } },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
